import { render, staticRenderFns } from "./EditLotGroupProps.vue?vue&type=template&id=25b74966"
import script from "./EditLotGroupProps.vue?vue&type=script&lang=js"
export * from "./EditLotGroupProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports